import {
  GetCmSheetFeedbacksCollaboratorResponse,
  UpdateCmSheetFeedbacksCollaboratorRequest,
} from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CmSheetFeedbacksCollaboratorsService = {
  async get(
    cmSheetId: number,
  ): Promise<GetCmSheetFeedbacksCollaboratorResponse> {
    const response =
      await httpClient.get<GetCmSheetFeedbacksCollaboratorResponse>(
        `v1/cm-sheets/${cmSheetId}/feedbacks-collaborator`,
      );
    return response;
  },
  async update(
    cmSheetId: number,
    body: UpdateCmSheetFeedbacksCollaboratorRequest,
  ): Promise<void> {
    await httpClient.put(
      `v1/cm-sheets/${cmSheetId}/feedbacks-collaborator`,
      body,
    );
  },
};

export default CmSheetFeedbacksCollaboratorsService;
